import {Localization} from 'core/localization/localization';

export const sharedLocalization = new Localization({
	'Dashboard property': {
		no: 'Dashboard innstillinger'
	},
});
